import React from "react";
import { Button } from "react-bootstrap";
import CustomModal from "../customModal/CustomModal";

interface SessionTimeoutWarningProps {
  show: boolean;
  remainingTime: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

const formatTime = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  show,
  remainingTime,
  onStayLoggedIn,
  onLogout,
}) => {
  if (!show) return null;

  return (
    <CustomModal
      title="Session Timeout Warning"
      content={
        <>
          <div className="modal--content--wrapper">
            <i
              className="bi bi-exclamation-triangle-fill"
              style={{ fontSize: "48px", color: "#f0ad4e" }}
            ></i>
            <h5>Your session is about to expire</h5>
            <p>
              You will be automatically logged out in{" "}
              <strong>{formatTime(remainingTime)}</strong>.
            </p>
            <p>Would you like to stay logged in?</p>
          </div>
          <div className="modal--action--btn--wrapper">
            <Button
              type="button"
              variant="outline-primary"
              onClick={onLogout}
            >
              Logout
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={onStayLoggedIn}
            >
              Stay Logged In
            </Button>
          </div>
        </>
      }
      onClose={onStayLoggedIn}
    />
  );
};

export default SessionTimeoutWarning;
